<div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-fit-content overflow-y-scroll">
    <div fxLayout="column" fxLayoutAlign="start center" class="w-100">
        <div class="h3 text-center mt-24">{{ 'i18n_af_title_viewResolution' | translate }}</div>
        <div fxLayout="column" fxLayoutAlign="start center" class="p-24" fxLayoutGap="24px">
            @if (resolution) {
                <div class="container bc-primary-gray-50 w-100">
                    <div fxLayout="row" fxLayoutAlign="start center">
                        <div class="t2-semi-bold">{{
                                'i18n_af_labelResolutionDate' | translate: {
                                    date: resolution.createdDate | date:'dd.MM.yy'
                                }
                            }}
                        </div>
                        <af-status class="ml-16" [statusText]="statusLabel(resolution.status)" [status]="resolution.statusStyle"/>
                    </div>
                    @for (field of resolution.fields; track field) {
                        <div class="info-container">
                            <div class="t2 c-primary-gray-600">{{ ('i18n_af_field_resolution#' + field.fieldName) | translate }}</div>
                            <div class="t2 c-primary-gray-900 break-word">{{ field.fieldValue }}</div>
                        </div>
                    }
                    @if (resolution.solutionInfo?.length) {
                        <div class="solution-info-section">
                            <div class="t2-semi-bold">{{ 'i18n_af_labelSolutionInfo' | translate }}</div>
                            <div class="solution-row solution-row--header mt-16">
                                <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#fullName' | translate }}</div>
                                <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#identificationNumber' | translate }}</div>
                                <div class="t5 c-primary-gray-600">{{ 'i18n_af_field_solution#category' | translate }}</div>
                            </div>
                            @for (solution of resolution.solutionInfo; track solution.id) {
                                <div class="solution-row">
                                    <div class="t2 c-primary-gray-900 break-word">{{ solution.fullName }}</div>
                                    <div class="t2 c-primary-gray-900">{{ solution.identificationNumber }}</div>
                                    <div class="t2 c-primary-gray-900">{{ ('i18n_af_category#' + solution.category) | translate }}</div>
                                </div>
                            }
                        </div>
                    }
                </div>
            }
        </div>
    </div>
</div>
